import { render, staticRenderFns } from "./DigitalOdontogram.vue?vue&type=template&id=363d391e&scoped=true"
import script from "./DigitalOdontogram.vue?vue&type=script&lang=js"
export * from "./DigitalOdontogram.vue?vue&type=script&lang=js"
import style0 from "./DigitalOdontogram.vue?vue&type=style&index=0&id=363d391e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363d391e",
  null
  
)

export default component.exports